import BoxTracker from "./BoxTracker";

export default BoxTracker;
export { BoxTracker };
